import { schemas, CreateActionBodyDtoType } from '@convergence/client';
import { fetch } from '../fetch';
import { useMutation } from '@tanstack/react-query';

export function createAction(body: CreateActionBodyDtoType) {
  return fetch(
    '/action',
    { method: 'POST', body: JSON.stringify(body) },
    schemas.ActionDto
  );
}

export const useCreateActionMutation = () => {
  const m = useMutation({
    mutationKey: ['createAction'],
    mutationFn: (body: CreateActionBodyDtoType) => createAction(body)
  });
  return m;
};
